import { render } from "./WalletWithdraw.vue?vue&type=template&id=10eb3088&scoped=true"
import script from "./WalletWithdraw.vue?vue&type=script&lang=js"
export * from "./WalletWithdraw.vue?vue&type=script&lang=js"

import "./WalletWithdraw.vue?vue&type=style&index=0&id=10eb3088&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10eb3088"]])

export default __exports__